(function () {
  function activateFirstVariants() {
    document
      .querySelectorAll('.collection .product-item .product-item__variant:first-child')
      .forEach(function (el) {
        el.classList.add('active');
      });
  }

  function setComboPriceText() {
    document.querySelectorAll('.combo .product-item__price').forEach(function (el) {
      el.textContent = 'Starting from ₹ 2500';
    });
  }

  function init() {
    activateFirstVariants();
    if (/\/collections\/[^/]*offers/.test(window.location.pathname)) {
      setComboPriceText();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.TBCollectionHelpers = {
    activateFirstVariants: activateFirstVariants,
    setComboPriceText: setComboPriceText
  };
})();
